import {
  proposalAuthorisedConstants,
  proposalOnAcceptanceConstants,
} from '../constants/actionTypes'

const initialState = {
  OnProposalAcceptance: {
    errorMsgOnAcceptingProposal: '',
    isSubmitting: false,
    submissionFailed: false,
    submittedForAcceptedProposal: false,
    errorMsgOnCancelAcceptedProposal: '',
    hasCancelSubmissionFailed: false,
    cancellationSubmittedForAcceptedProposal: false,
    isCancelRequestSubmitting: false,
  },
  proposal: null,
}

export default function proposalReducer(state = initialState, action) {
  switch (action.type) {
    case proposalAuthorisedConstants.PROPOSAL_AUTHORISED:
      return {
        ...state,
        isProposalAuthorised: true,
      }
    case proposalAuthorisedConstants.PROPOSAL_NOT_AUTHORISED:
      return {
        ...state,
        isProposalAuthorised: false,
      }
    case proposalAuthorisedConstants.PROPOSAL_ID_RECEIVED:
      return {
        ...state,
        proposal: action.payload,
      }
    case proposalOnAcceptanceConstants.PROPOSAL_ACCEPTANCE_SUCCESS:
      return {
        ...state,
        OnProposalAcceptance: {
          errorMsgOnAcceptingProposal: '',
          isSubmitting: false,
          submissionFailed: false,
          submittedForAcceptedProposal: true,
          errorMsgOnCancelAcceptedProposal: '',
          hasCancelSubmissionFailed: false,
          cancellationSubmittedForAcceptedProposal: false,
          isCancelRequestSubmitting: false,
        },
      }
    case proposalOnAcceptanceConstants.PROPOSAL_ACCEPTANCE_FAILED:
      return {
        ...state,
        OnProposalAcceptance: {
          errorMsgOnAcceptingProposal: action.payload,
          isSubmitting: false,
          submissionFailed: true,
          submittedForAcceptedProposal: false,
          errorMsgOnCancelAcceptedProposal: '',
          hasCancelSubmissionFailed: false,
          cancellationSubmittedForAcceptedProposal: false,
          isCancelRequestSubmitting: false,
        },
      }
    case proposalOnAcceptanceConstants.PROPOSAL_ACCEPTANCE_SUBMITTING:
      return {
        ...state,
        OnProposalAcceptance: {
          errorMsgOnAcceptingProposal: '',
          isSubmitting: true,
          submissionFailed: false,
          submittedForAcceptedProposal: false,
          errorMsgOnCancelAcceptedProposal: '',
          hasCancelSubmissionFailed: false,
          cancellationSubmittedForAcceptedProposal: false,
          isCancelRequestSubmitting: false,
        },
      }
    case proposalOnAcceptanceConstants.CANCEL_PROPOSAL_ACCEPTANCE_SUCCESS:
      return {
        ...state,
        OnProposalAcceptance: {
          errorMsgOnAcceptingProposal: '',
          isSubmitting: false,
          submissionFailed: false,
          submittedForAcceptedProposal: false,
          errorMsgOnCancelAcceptedProposal: '',
          hasCancelSubmissionFailed: false,
          cancellationSubmittedForAcceptedProposal: true,
          isCancelRequestSubmitting: false,
        },
      }
    case proposalOnAcceptanceConstants.CANCEL_PROPOSAL_ACCEPTANCE_FAILED:
      return {
        ...state,
        OnProposalAcceptance: {
          errorMsgOnAcceptingProposal: '',
          isSubmitting: false,
          submissionFailed: false,
          submittedForAcceptedProposal: false,
          errorMsgOnCancelAcceptedProposal: action.payload
            .replace('500', '')
            .replace('400', ''),
          hasCancelSubmissionFailed: true,
          cancellationSubmittedForAcceptedProposal: false,
          isCancelRequestSubmitting: false,
        },
      }
    case proposalOnAcceptanceConstants.CANCEL_PROPOSAL_ACCEPTANCE_SUBMITTING:
      return {
        ...state,
        OnProposalAcceptance: {
          errorMsgOnAcceptingProposal: '',
          isSubmitting: false,
          submissionFailed: false,
          submittedForAcceptedProposal: false,
          errorMsgOnCancelAcceptedProposal: '',
          hasCancelSubmissionFailed: false,
          cancellationSubmittedForAcceptedProposal: false,
          isCancelRequestSubmitting: true,
        },
      }

    default:
      return state
  }
}
